// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#emptycontent[data-v-4512145e]{margin-top:10px}", "",{"version":3,"sources":["webpack://./src/components/EmptyMailboxSection.vue"],"names":[],"mappings":"AAYA,+BACC,eAAA","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n#emptycontent {\n\tmargin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
